const IMPORTANT_INFO_URL = `${process.env.REACT_APP_API_URL}/api/important_info`;
const STATIC_END_POINT = '/api/user/authenticate';

export { STATIC_END_POINT, IMPORTANT_INFO_URL };
